<section class="welcome-page">
  <app-welcome-banner [bgImage]="leftBannerImgurl"></app-welcome-banner>
  <div class="welcome-content">
    <div class="welcome-form-area">
      <h2 class="welcome-title">Forgot Password ?</h2>
      <p class="notify-text">Looks like you’ve forgotten your password.
        Enter the Username associated to you O3 Smart Manufacturing account and we’ll send over a link.</p>
      <form [formGroup]="ForgotPassword">
        <div class="form-group">
          <label class="label" for="username">Username</label>
          <div style="display:flex;">
          <input style="
          width: 390px;" [ngClass]="{
              'is-invalid':
                ForgotPassword.get('username')?.errors &&
                ForgotPassword.get('username')?.touched
            }" type="text" formControlName="username" class="form-control" 
            placeholder="Enter your Username "/>
            <button
            mat-mini-fab
            mat-button
            [disabled]=" ForgotPassword.get('username')?.errors"
            (click)="ValidateUserName()"
            pTooltip="Search User"
            color="accent"
            tooltipPosition="top"
            style="margin-left: 20px; margin-top: 4px;"
          >
            <i class="fa fa-search" style="color: #fff"></i>
          </button>
        </div>
            <p class="invalid-feedback" *ngIf="
            ForgotPassword.get('username')?.touched &&
            ForgotPassword.get('username')?.hasError('required')
          ">
              * invalid username
            </p>
            <p
            class="invalid-feedback"
            *ngIf="
              ForgotPassword.get('username')?.hasError('username') &&
              ForgotPassword.get('username')?.touched
            "
          >
            * invalid username
          </p>

          <mat-radio-group formControlName="type" *ngIf="IsValidated" (change)="changeMode($event)" >
            <mat-radio-button style="margin-top:20px"  [value]="1" [checked]="true">Email</mat-radio-button>
            <mat-radio-button style="margin-top:20px" *ngIf="HasWhatsapp" [value]="2"   style="margin: 0 20px 0 20px;">WhatsApp</mat-radio-button>
          </mat-radio-group>
          <p style="margin-top:20px" *ngIf="EmailMode" >Your Password will be send to this email: <b>{{UserEmail}}</b></p>
          <p style="margin-top:20px" *ngIf="WhatsAppMode" >Your Password will be send to this WhatsApp number: <b>{{WhatsAppNo}}</b></p>
        </div>

       
        <div class="d-flex justify-content-front align-items-center">
          
          <button mat-flat-button color="accent" [disabled]="!ForgotPassword.valid" class="btn-accent btn-lg" (click)="onSubmit()">Submit</button>
          <button mat-button class="login-cancel-btn" routerLink="/login">Back</button>
        </div>
      </form>
    </div>

  </div>

</section>